import { render } from "./TitlebarButtons.vue?vue&type=template&id=385f8a1a&scoped=true&bindings={}"
import script from "./TitlebarButtons.vue?vue&type=script&lang=ts"
export * from "./TitlebarButtons.vue?vue&type=script&lang=ts"

import "./TitlebarButtons.vue?vue&type=style&index=0&id=385f8a1a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-385f8a1a"

export default script